/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */
export type InfusionConfig = {
  readonly infusions: InfusionType[];
  readonly defaultInfusion?: string;
  readonly defaultAccessRoute?: string;
};

export type InfusionType = {
  readonly key: string;
  readonly label: string;
  readonly defaultVolume?: InfusionVolume;
};

export type InfusionValue = {
  readonly infusion?: string;
  readonly volume?: InfusionVolume;
  readonly accessRoute?: string;
  readonly pressureInfusion?: PressureInfusion;
};

export type InfusionVolume = {
  readonly value: number;
};

export enum PressureInfusion {
  IS_PRESSURE_INFUSION = 'IS_PRESSURE_INFUSION',
  VALUE_NOT_AVAILABLE = 'VALUE_NOT_AVAILABLE',
}

export type InfusionElementType = 'infusion';
